import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { store } from '@monorepo/redux';
import flagsmith from 'flagsmith';
import { FlagsmithProvider } from 'flagsmith/react';
import App from './app/app';
import './styles.scss';

import i18n from '~/locales/i18n';
import { I18nextProvider } from 'react-i18next';

// antd Table/Tabs trigger the browser's benign "ResizeObserver loop completed with undelivered
// notifications" warning. CRA's dev overlay listens for the window 'error' event as a normal
// (bubble-phase) listener; a capture-phase listener on the same target always runs first
// regardless of registration order, so this reliably stops the overlay before it ever sees it.
window.addEventListener(
  'error',
  (e) => {
    if (e.message?.includes('ResizeObserver loop')) {
      e.stopImmediatePropagation();
    }
  },
  { capture: true }
);

// Also debounce the observer callback itself so the loop condition fires less often in the first place.
if (window.ResizeObserver) {
  const NativeResizeObserver = window.ResizeObserver;
  window.ResizeObserver = class DebouncedResizeObserver extends NativeResizeObserver {
    constructor(callback) {
      let frame = 0;
      super((...args) => {
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(() => callback(...args));
      });
    }
  };
}

flagsmith
  .init({
    api: process.env.REACT_APP_FLAGSMITH_URL,
    environmentID: process.env.REACT_APP_FLAGSMITH_ENVIRONMENT_ID,
    cacheFlags: true,
  })
  .then(() => {
    flagsmith.startListening(60000);
  });

ReactDOM.render(
  <React.StrictMode>
    <FlagsmithProvider flagsmith={flagsmith}>
      <I18nextProvider i18n={i18n}>
        <Provider store={store}>
          <App />
        </Provider>
      </I18nextProvider>
    </FlagsmithProvider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
